/* begin deal details tabs */
$('.js-tablinks').click(function H() {
    let index = $(this).index();
    $(this).addClass('active');
    $('.js-tablinks.active').not($(this)).removeClass('active');
    $('.js-tabcontent').eq(index).addClass('active');
    $('.js-tabcontent.active').not($('.js-tabcontent').eq(index))
        .removeClass('active');
});
/* end deal details tabs */
